import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import settingDrawer from './zh-CN/settingDrawer';
export default _objectSpread({}, settingDrawer);